import { Fragment, memo } from 'react'

import useTranslations from '../../../hooks/useTranslations'
import ANTDCard from '../../../shared/antd/ANTDCard'
import ANTDColumn from '../../../shared/antd/ANTDColumn'
import ANTDPagination from '../../../shared/antd/ANTDPagination'
import { noImage } from '../../../utils/icons'
import { length, ternary } from '../../../utils/javascript'

const UserTableCard = ({ data, actionButtons, cardViewFn }) => {
  const { t } = useTranslations()

  return (
    <>
      {length(data) ? (
        data?.map(item => (
          <Fragment key={item.id}>
            <ANTDCard
              key={item.id}
              className="list-card-view"
              title={`${t('user_ID')} : ${item?.id}`}
              extra={<>{actionButtons(item)}</>}
            >
              <div className="card-details-container d-flex flex-wrap space-between flex-row-reverse">
                <ANTDColumn sm={5} xs={24}>
                  <div className="card-img-wrap">
                    <img src={item?.profileUrl || noImage} alt={'profile'} />
                  </div>
                </ANTDColumn>
                <ANTDColumn sm={19} xs={24}>
                  <div>
                    <table>
                      <tbody>
                        {cardViewFn(item)?.map(({ label, value }, index) => (
                          <tr key={index}>
                            <td>
                              <b>{t(label)}</b>
                            </td>
                            <td> : {ternary(value, value, '-')}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </ANTDColumn>
              </div>
            </ANTDCard>
            <div className="pagination-container">
              <ANTDPagination
                total={0}
                showSizeChanger={false}
                responsive
                hideOnSinglePage
              />
            </div>
          </Fragment>
        ))
      ) : (
        <ANTDCard className="list-card-view">
          <h4 className="text-center">{t('noData')}</h4>
        </ANTDCard>
      )}
    </>
  )
}

export default memo(UserTableCard)
